import React from 'react'
import CopyPlanFileDetail from '../../plan/CopyPlanFileDetail'
import V3PlanRouteShell from './V3PlanRouteShell'

export default function V3CopyPlanLineDetailPage() {
  return (
    <V3PlanRouteShell>
      <CopyPlanFileDetail mode="line" visualVariant="v3" />
    </V3PlanRouteShell>
  )
}

